
import React, { useEffect, useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom"
import { useSelector } from 'react-redux';
import { IKImage, IKContext } from 'imagekitio-react';

import serialize from '../utils/html-serializer'
import getImageSrc from "../utils/get-image-src";

import './promotionTile.scss';

export default function PromotionTile({ promotion, featured }) {

	const navigate = useNavigate();
	const locale = useSelector((state) => state.globalContent.data.locale);
	const [modalShow, setModalShow] = useState(false)

	const modalToggle = () => { setModalShow(!modalShow) };
	const claimPromotion = () => {
		if (!promotion) return;
		// if (promotion.url) { navigate(promotion.url); }
		if (promotion.isLoggedOutPromotion) { navigate(`/${locale}?register&promo=${promotion.id}`); return; }
		if (promotion.game) { navigate(`/${locale}/game/${promotion.game.id}`); return; }

		if (promotion.bonus) {
			if (promotion.bonus.activationType === 'DEPOSIT') {
				navigate(`/${locale}/profile/deposit/${promotion.bonus.promoCode}`);
			}

			// if (promotion.bonus.activationType === 'FREE') {
			// 	navigate(`promocode/${promotion.bonus.promoCode}`);
			// }
		}
	}

	useEffect(() => { })

	return (!promotion ? null : (
		<>
			{/* Promotion */}
			<div className={featured ? 'featured-promotion-tile-container' : 'promotion-tile-container'} >
				<div className="promotion-tile-image-wrapper">
					<img className="promotion-tile-image" src={getImageSrc(promotion?.image)} alt="" />
				</div>
				<div className="promotion-tile-content">
					<div>
						{
							!promotion?.badge ? null :
								<span className="promotion-tile-badge mb-0">{promotion.badge}</span>
						}
						{
							!promotion?.title ? null :
								<h2 className="subtitle white-100 mb-1">{promotion.title}</h2>
						}
						{
							!promotion?.subtitle ? null :
								<p className="">{promotion.subtitle}</p>
						}
					</div>
					<div className="promotion-tile-buttons">
						{
							promotion?.url ? (
								<a className="btn-main mt-1 mb-1" href={promotion?.url}>
									{promotion?.cta || 'Play now'}
								</a>
							) : (
								<Button className="btn-main mt-1 mb-1" onClick={claimPromotion}>
									{promotion?.cta || 'Play now'}
								</Button>
							)
						}
						<Button className="btn-secondary mt-1 mb-1 ms-2" onClick={modalToggle}>Learn more</Button>
					</div>
				</div>
			</div>

			{/* Modal */}
			<Modal show={modalShow} onHide={modalToggle} size="lg" scrollable={true} >
				<Modal.Header style={{ flexDirection: 'column' }}>
					<h1 className="h4 mb-1">{promotion?.title}</h1>
					<p className="mb-0">{promotion?.subtitle}</p>
				</Modal.Header>
				<Modal.Body className="modal_body_scroll">
					<div dangerouslySetInnerHTML={{ __html: promotion?.description?.map(node => serialize(node)).join('') }}></div>
				</Modal.Body>
				<Modal.Footer>
					<Button className='btn-secondary ps-4 pe-4' onClick={modalToggle}>Close</Button>
					{
						promotion?.url ? (
							<a className="btn-main ps-4 pe-4" href={promotion?.url}>
								{promotion?.cta || 'Play now'}
							</a>
						) : (
							<Button className="btn-main ps-4 pe-4" onClick={claimPromotion}>
								{promotion?.cta || 'Play now'}
							</Button>
						)
					}
					{/* <Button className="btn-main ps-4 pe-4" onClick={claimPromotion}>{promotion?.cta || 'Play now'}</Button> */}
				</Modal.Footer>
			</Modal >
		</>)
	);
}